import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import {CoreModule, UtilityService} from '@app/core';
import { SharedModule } from '@app/shared';
import { AccreditedRoutingModule } from './accredited-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ShoppingService} from '@app/shopping/shopping.service';
import {AccreditedComponent} from '@app/accredited/accredited.component';
import {AccreditedLateralMenuComponent} from '@app/accredited-lateral-menu/accredited-lateral-menu.component';
import {AccreditedService} from '@app/accredited/accredited.service';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import {NgxMaskModule} from 'ngx-mask';
import {QRCodeModule} from 'angularx-qrcode';
import {AccreditedReceiptComponent} from '@app/accredited-receipt/accredited-receipt.component';
import {NgxPaginationModule} from 'ngx-pagination';
import {AuthenticationService} from '@app/core/authentication/authentication.service';
import {CpfCnpjModule} from 'ng2-cpf-cnpj';
import {AccreditedModalContentComponent} from '@app/accredited-modal/accredited-modal.component';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    AccreditedRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    NgxMaskModule.forRoot(),
    QRCodeModule,
    NgxPaginationModule,
    CpfCnpjModule,
    TextMaskModule
  ],
  declarations: [
    AccreditedComponent,
    AccreditedReceiptComponent,
    AccreditedLateralMenuComponent,
    AccreditedModalContentComponent
  ],
  providers: [
    ShoppingService,
    AccreditedService,
    UtilityService,
    AuthenticationService
  ],
  entryComponents: [AccreditedModalContentComponent]

})
export class AccreditedModule { }



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/accredited/accredited.module.ts